export function HasDash(str) {
    // Gunakan metode .indexOf() untuk mencari karakter "-" di dalam string
    // Jika karakter tersebut ditemukan, maka .indexOf() akan mengembalikan indeksnya
    // Jika tidak ditemukan, maka .indexOf() akan mengembalikan -1
    return str.indexOf('-') !== -1;
  }